module.exports = __webpack_public_path__ + "static/media/lapin-bleu.b028afc2.gif";